import { assignmentDetailsRoutes } from './features/assignment-details/assignment-details.routes';
import { assignmentsListingRoutes } from './features/assignments-listing/assignments-listing.routes';

export const assignmentsRoutes = [
  {
    path: '/assignments',
    name: 'assignments',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "assignments" */ './Assignments.vue'),
    children: [
      {
        path: 'batch-update',
        name: 'assignments-batch-update',
        component: () =>
          import(/* webpackChunkName: "assignments-batch-update" */ '../../features/batch-update/BatchUpdateListing.vue')
      },
      ...assignmentsListingRoutes,
      ...assignmentDetailsRoutes
    ]
  }
];
